import { useTenant } from '../auth/TenantContext';
import { useCanEditWorkspace } from '../auth/useWorkspaceAdmin';
import { EmptyState } from '../components/ui/States';
import { BrandSetupWizard } from '../features/brand-setup/BrandSetupWizard';
import { MembersRefusal } from '../features/brand-setup/MembersRefusal';
import { WizardFrame } from '../features/brand-setup/WizardFrame';

/**
 * Brand Setup, the full-height onboarding wizard (`/workspace/setup`, while Brand Workspace v2 is on;
 * web.md §4.1). For the workspace the URL names (`?ws=`):
 * - a member who cannot change its brand gets the refusal, and nothing is read or written;
 * - anyone else gets the wizard, keyed by the workspace, so a switch starts it afresh (after the leave
 *   check).
 */
export function BrandSetupPage() {
  const { activeTenant } = useTenant();
  const canEdit = useCanEditWorkspace(activeTenant?.id);

  if (!activeTenant) {
    return (
      <WizardFrame>
        <EmptyState title="No active workspace" description="Select or create a Brand Workspace first." />
      </WizardFrame>
    );
  }
  if (!canEdit) return <MembersRefusal slug={activeTenant.slug} />;
  return <BrandSetupWizard key={activeTenant.id} tenant={activeTenant} />;
}
